import en from './en';
import de from './de';
import fr from './fr';
import es from './es';
import zhTW from './zh-TW';
import zhCN from './zh-CN';
import ja from './ja';
import ko from './ko';

const locales = { en, de, fr, es, 'zh-TW': zhTW, 'zh-CN': zhCN, ja, ko };

export function getLocale(lang) {
  return locales[lang] || en;
}

export function makeT(locale) {
  return (key, ...args) => {
    const val = locale[key];
    if (val === undefined) return key;
    return typeof val === 'function' ? val(...args) : val;
  };
}
